<template>
  <div class="d-block d-md-none">
    <v-bottom-navigation color="primary" fixed height="70">
      <template v-for="(item, index) in menu">
        <template v-if="item.show">
          <template v-if="!item.external">
            <v-btn class="px-0 bottom-link" link :key="index" :to="item.link">
              <template>
                <span style="font-size: 8px">{{ item.name }}</span>
                <template v-if="item.counter">
                  <v-badge size="20" offset-x="-2" color="success" overlap>
                    <template #badge>
                      <span style="font-size: 10px">{{ item.counter }}</span>
                    </template>
                    <v-icon size="20">{{ item.icon }}</v-icon>
                  </v-badge>
                </template>
                <template v-else>
                  <v-icon size="20">{{ item.icon }}</v-icon>
                </template>
              </template>
            </v-btn>
          </template>
          <template v-else>
            <v-btn class="px-0 bottom-link" link :key="index" :href="item.link">
              <span style="font-size: 8px">{{ item.name }}</span>
              <template v-if="item.counter">
                <v-badge
                  color="green"
                  :content="item.counter"
                  overlap
                  :value="item.counter"
                >
                  <v-icon size="20">{{ item.icon }}</v-icon>
                </v-badge>
              </template>
              <template v-else>
                <v-icon size="20">{{ item.icon }}</v-icon>
              </template>
            </v-btn>
          </template>
        </template>
      </template>
    </v-bottom-navigation>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      value: 1,
    };
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("cart", ["cartData"]),

    isAuth() {
      return this.$store.state.auth.isAuth;
    },
    isReseller() {
      if (!this.userData) return false;
      return ["seller", "stockist", "reseller"].includes(
        this.userData.user_type
      );
    },
    menu() {
      let authMenu = [
        {
          name: "Home",
          show: this.$route.path !== "/",
          link: process.env.VUE_APP_HOMEPAGE,
          external: true,
          icon: "mdi-home-outline",
        },
        {
          name: "Toko Saya",
          show: this.isReseller,
          link: "/seller/dashboard",
          external: false,
          icon: "mdi-store-outline",
        },
        {
          name: "Keranjang",
          show: true,
          counter: this.cartProduk(this.cartData),
          link: process.env.VUE_APP_HOMEPAGE + "cart",
          external: true,
          icon: "mdi-cart-outline",
        },
        {
          name: "Transaksi",
          show: true,
          link: "/transaction",
          external: false,
          icon: "mdi-text-box-outline",
        },
        {
          name: "Akun",
          show: this.isAuth,
          link: "/profile",
          // external: true,
          icon: "mdi-account-outline",
        },
        // {
        //   name: "Logout",
        //   show: this.isAuth,
        //   link:  '/logout',
        //   icon: "mdi-cart-outline",
        // },
      ];
      return [...authMenu];
    },
  },
  methods: {
    cartProduk(data) {
      let count = 0;
      data.forEach((el) => {
        el.cart_detail.forEach(() => {
          count += 1;
        });
      });
      return count;
    },
    redirectToWa() {
      return (window.location.href =
        "https://wa.me/" + process.env.VUE_APP_CS_NUMBER);
    },
  },
};
</script>

<style lang="scss" scoped></style>
